module.exports = __webpack_public_path__ + "img/PGR_A05_back_cross_diagonal_en.4fbb9157.png";